import { JSX } from "react";
import { useTranslation } from "react-i18next";

import Checkbox from "@mui/material/Checkbox";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";

import { ListInfo } from "utils/list/List";
import { asTitle } from "utils/Utils";

import BlueprintRow from "core/blueprint/base/BlueprintRow";
import { BlueprintInfo } from "core/blueprint/base/BlueprintService";

export type BlueprintTableProps = {
	elements: BlueprintInfo[];
	listInfo: ListInfo<number>;
	showLibraryStatus?: boolean;

	onSelect: (keys: number[], selected: boolean) => void;
};

const BlueprintTable: React.FC<BlueprintTableProps> = (
	props: BlueprintTableProps
) => {
	const { t } = useTranslation();

	function getRows(): JSX.Element[] {
		const elements: JSX.Element[] = [];
		for (const element of props.elements) {
			if (props.listInfo.isVisible(element.id)) {
				elements.push(
					<BlueprintRow
						key={element.id}
						blueprint={element}
						showLibraryStatus={props.showLibraryStatus}
						selected={props.listInfo.isSelected(element.id)}
						onSelect={select =>
							props.onSelect([element.id], select)
						}
					/>
				);
			}
		}

		return elements;
	}

	return (
		<Table size="small">
			<TableHead>
				<TableRow>
					<TableCell
						id="select-header"
						align="center"
						padding="checkbox">
						<Checkbox
							id="select-all"
							checked={props.listInfo.allVisibleSelected()}
							indeterminate={props.listInfo.someVisibleSelected()}
							onChange={(_event, checked) =>
								props.onSelect(
									props.listInfo.getVisibleKeys(),
									checked
								)
							}
						/>
					</TableCell>
					<TableCell id="type-header">{asTitle(t("type"))}</TableCell>
					<TableCell id="name-header">{asTitle(t("name"))}</TableCell>
					<TableCell id="name-header">
						{asTitle(t("description"))}
					</TableCell>
					<TableCell padding="none" />
				</TableRow>
			</TableHead>
			<TableBody>{getRows()}</TableBody>
		</Table>
	);
};

export default BlueprintTable;
